module.exports = __webpack_public_path__ + "img/tooltip.09644264.svg";